import React from "react";
import { useTheme } from "@mui/material/styles";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import Container from "@mui/material/Container";
import TableContainer from "@mui/material/TableContainer";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CommonTableHeaders from "./TableHeaders/CommonTableHeaders";
import WaitlistTableBody from "./TableBodys/WaitlistTableBody";

interface GameInfo {
  id: string;
  waitlist: { [key: string]: any };
  [key: string]: any;
}

interface WaitlistTableProps {
  gameInfo: GameInfo;
  setModalDets: (dets: any) => void;
}

const WaitlistTable: React.FC<WaitlistTableProps> = ({
  gameInfo,
  setModalDets,
}) => {
  const theme = useTheme();
  const { waitlist } = gameInfo;

  if (Object.keys(waitlist).length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Nobody currently on Waitlist
        </Typography>
      </Box>
    );
  }
  return (
    <Container>
      <TableContainer
        component={Paper}
        sx={{
          ...theme.table?.defaultContainer,
          textAlign: "center",
          margin: "auto",
          padding: "auto",
          borderRadius: "20px",
        }}
        elevation={5}
      >
        <Table>
          <CommonTableHeaders />
          <WaitlistTableBody setModalDets={setModalDets} gameInfo={gameInfo} />
        </Table>
      </TableContainer>
    </Container>
  );
};

export default WaitlistTable;
